module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/5_a55f52bff4c1b4c6aca8d6aa5eb9d85d.png";